import * as plugins from '../plugins.js';
import type * as authInterfaces from '../data/auth.js';
import type { IEmailServerSettings, TEmailServerSettingsUpdate } from '../data/email-settings.js';

export interface IReq_GetEmailServerSettings extends plugins.typedrequestInterfaces.implementsTR<
  plugins.typedrequestInterfaces.ITypedRequest,
  IReq_GetEmailServerSettings
> {
  method: 'getEmailServerSettings';
  request: {
    identity?: authInterfaces.IIdentity;
    apiToken?: string;
  };
  response: {
    settings: IEmailServerSettings;
  };
}

export interface IReq_UpdateEmailServerSettings extends plugins.typedrequestInterfaces.implementsTR<
  plugins.typedrequestInterfaces.ITypedRequest,
  IReq_UpdateEmailServerSettings
> {
  method: 'updateEmailServerSettings';
  request: {
    identity?: authInterfaces.IIdentity;
    apiToken?: string;
    settings: TEmailServerSettingsUpdate;
  };
  response: {
    success: boolean;
    settings?: IEmailServerSettings;
    message?: string;
  };
}
